import React, { Component } from "react";
import { 
    Table,
    OverlayTrigger,
    Tooltip,
    Row,
    Grid,
    Col,
} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import CustomValueModal from "./CustomValueModal";
import { editEmployeeRequest } from "../../api/employee"
import { formatPrice } from "../../helpers/functions/pricing";
import moment from "moment";

class CustomValuesPayroll extends Component  {

    constructor(props) {
        super(props)
        this.state = {
            showModal: false,
            modalType: null,
            error: null,
            customValueData: {
                period: '',
                extraPagIbig: ''
            }
        }
    }

    handleCustomValueModal = (type, data) => {

        this.setState({
            customValueData: {},
            showModal: !this.state.showModal,
            modalType: type
        })
        if (type === "edit") {
            this.setState({
                customValueData: data
            })
        }

    }

    deleteCustomValue = async (employee, value) => {
        const { _id } = this.props.employee;
        let data = {
            customValue : {
                delete: true,
                _id: value
            }
        };

        await editEmployeeRequest(employee, data);
        await this.props.fetchEmployee(_id);
    }

    handleCustomValue = async (data) => {
        try {
            const {_id} = this.props.employee;

            if( !data.customValue.period || !data.customValue.extraPagIbig ) {
                this.setState({
                    error: "All fields must be filled"
                })
                return;
            }

            await editEmployeeRequest(_id, data,
                result => this.saveSuccess(),
                error => this.saveFailure(error)
            );
            await this.props.fetchEmployee(_id)
            this.setState({
                showModal: false,
                error: false,
            })
        } catch (err) {
            console.log(err)
        }
    }


    saveSuccess = () => {
        this.setState({ 
            error: null,
        });
    }
    
    saveFailure = (error) => {
        this.setState({ 
            error: error.message,
        })
    }


    render() {
        
        const {
            showModal,
            modalType,
            error,
            customValueData
        } = this.state;

        const {
            readOnly,
            employee
        } = this.props;


        // const view = <Tooltip id="view_tooltip">View</Tooltip>;
        const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
        const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

        return (
            <div cclassName="content">
                <Grid fluid>
                    <Row>
                        <Col md={12} className="p-0">
                            <Card
                                title="Custom values for Payroll"
                                category="Values will be used for payroll calculation if present"
                                ctTableFullWidth
                                ctTableResponsive
                                content={
                                    <div>
                                        <CustomButtom className={readOnly ? "d-none table-top-btn btn-primary" : "table-top-btn btn btn-primary"} onClick={() => this.handleCustomValueModal("create")}>
                                            New Entry
                                        </CustomButtom>
                                        <Table>
                                            <thead>
                                                <tr>
                                                    <th>Period</th>
                                                    <th>Extra Pag-Ibib</th>
                                                    <th  className={readOnly ? "d-none td-actions text-right" : "td-actions text-right"}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                            {this.props.loading ?
                                                <td colSpan="3" style={{padding: "0"}}>
                                                    <div className="loader"></div>
                                                </td> 
                                            :
                                                (employee.customValues && employee.customValues.length > 0) ?
                                                employee.customValues.map((value) => (
                                                    <tr key={value._id}>
                                                        <td>{moment.utc(value.period).format('MMMM/yyyy') || "N/A"}</td>
                                                        <td>{value.extraPagIbig ? `PHP ${formatPrice(value.extraPagIbig)}`: "N/A"}</td>
                                                        <td className={readOnly ? "d-none td-actions text-right" : "td-actions text-right"}>
                                                            <OverlayTrigger placement="top" overlay={edit}>
                                                            <CustomButtom 
                                                                bsStyle="info" 
                                                                simple 
                                                                type="button" 
                                                                bsSize="xs"
                                                                onClick={() => this.handleCustomValueModal("edit", value)}
                                                            >
                                                                <i className="fa fa-edit" />
                                                            </CustomButtom>
                                                            </OverlayTrigger>

                                                            <OverlayTrigger placement="top" overlay={remove}>
                                                            <CustomButtom 
                                                                bsStyle="danger" 
                                                                simple 
                                                                type="button" 
                                                                bsSize="xs"
                                                                onClick={() => this.deleteCustomValue(employee._id, value._id)}
                                                            >
                                                                <i className="fa fa-times" />
                                                            </CustomButtom>
                                                            </OverlayTrigger>
                                                        </td>
                                                    </tr>
                                                ))
                                                :
                                                <tr>
                                                    <td colSpan='5'>There are no custom values in the database yet.</td>
                                                </tr>
                                            }
                                            
                                    
                                            </tbody>
                                        </Table>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
                <CustomValueModal 
                    customValueData={customValueData}
                    showModal={showModal}
                    closeModal={this.handleCustomValueModal}
                    modalType={modalType}
                    handleCustomValue={this.handleCustomValue}
                    error={error}
                />
            </div>
        )
    }
}

export default CustomValuesPayroll;